import { createFileRoute } from '@tanstack/react-router';
import Icon from '@/components/ui/Icon.jsx';
import ResearchProfileView from '@/pages/ResearchProfileView.jsx';
import { getSharedResearchProfile } from '@/api';

function PendingShare() {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: 60 }}>
      <span className="spinner" />
    </div>
  );
}

function SharedProfileError({ error }) {
  return (
    <div className="empty-state">
      <Icon name="alert" size={36} stroke={1.5} />
      <h3>This link isn&rsquo;t available</h3>
      <p>
        {error?.status === 404 || error?.status === 410
          ? 'This shared link has expired or is no longer valid.'
          : (error?.message || 'This shared link may have expired or is invalid.')}
      </p>
    </div>
  );
}

function SharedProfileRoute() {
  const profile = Route.useLoaderData();
  // No onBack — a public viewer has nowhere authenticated to go back to.
  // ResearchProfileView hides its breadcrumb-back-link and owner-only
  // action bar (Watch/Share/Export PDF/Generate brief) whenever onBack
  // is absent.
  return <ResearchProfileView profile={profile} />;
}

export const Route = createFileRoute('/shared/$token')({
  loader: ({ params }) => getSharedResearchProfile(params.token),
  component: SharedProfileRoute,
  pendingComponent: PendingShare,
  errorComponent: SharedProfileError,
});
